import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { HttpHeaderNames } from "@touchtech/web-api-client";
import { TenantIdContext } from "@touchtech/web-tenant-id-provider";

import { LocalStorageKeys, ROUTES, TranslationContext } from "@is/constants";
import useSavePageUrl from "@is/hooks/useSavePageUrl";
import { LocalStorageService } from "@is/services";
import { api } from "@is/services/api";

function useManageBestsellerTenants() {
  const navigate = useNavigate();
  const { t } = useTranslation(TranslationContext.DeviceRegistration);
  const [, setTenant] = useContext(TenantIdContext);

  useSavePageUrl();

  const handleTenantSelectionClick = useCallback(
    (event: React.SyntheticEvent<HTMLDivElement>) => {
      const tenantId = event.currentTarget.getAttribute("data-id");

      if (tenantId) {
        setTenant(tenantId);
        LocalStorageService.setItem(LocalStorageKeys.TenantId, tenantId);

        api.setHeader(HttpHeaderNames.TENANT_ID, tenantId);
        navigate(ROUTES.Registration);
      }
    },
    [navigate, setTenant]
  );

  return { t, handleTenantSelectionClick };
}

export default useManageBestsellerTenants;
